<ion-header>
  <ion-toolbar>
    <ion-title>Fehlende Arbeitszeiten</ion-title>
    @if(!state.isBigScreen){
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    } @if(state.isBigScreen){
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="custom-table">
    <div class="row header">
      <div class="col">
        <ion-checkbox
          [(ngModel)]="allSelected"
          (ionChange)="toggleAll($event.detail.checked)"
          (click)="$event.stopPropagation()"
        ></ion-checkbox>
      </div>

      <div class="col">Datum</div>
      <div class="col grow">Name</div>
    </div>

    <div class="row" *ngFor="let entry of entries">
      <div class="col">
        <ion-checkbox
          (click)="$event.stopPropagation()"
          [checked]="isSelected(entry.id)"
          (ionChange)="toggleSelection(entry.id, $event.detail.checked)"
        >
        </ion-checkbox>
      </div>
      <div class="col">{{ entry.date | date : "EE, dd.MM.yyyy" }}</div>
      <div class="col grow">
        {{ state.getUserDisplayNameAsync(entry.user) | async }}
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar style="padding: 0 10px">
    <ion-button
      expand="block"
      color="danger"
      [disabled]="selectedIds.size == 0"
      (click)="delete()"
    >
      Löschen
    </ion-button>
  </ion-toolbar>
</ion-footer>
